import React, {Component} from 'react';

//podczas liczenia dodac film
class ProgressInfo extends Component {
  render () {
    
    
    return [
      
        <div className="progress-info" key={1}>
          <p className="comparison-in-progress">Trwa porównywanie...</p>
          
        </div>
     
    ]
  }
}



export default (ProgressInfo);

